export default __webpack_public_path__ + "static/1-44b2f2829ea5b6d3cc5b53412fed602c.png";